		/**
		 * @ngdoc service
		 * @name WebCoreModule.service:WcAuthorizationService
		 * @requires WebCoreModule.service:WcHttpEndpointPrototype
		 * @requires WebCoreModule.service:WcAuthorizationCacheHelper
		 * @requires _
		 * @requires $q
		 * @requires WcConstants
		 * @requires $state
		 * @description
		 * The WcAuthorizationService communicates with a specified restful endpoint to determine whether a user is authorized for a
		 * resource or not. The service exposes functions to assist in decisions for whole states or even specific resources.
		 */

angular.module('WebCoreModule')
	.service('WcAuthorizationService', ['WcHttpEndpointPrototype', 'WcAuthorizationCacheHelper', '_', '$q', 'WcConstants', '$state', function(WcHttpEndpointPrototype, WcAuthorizationCacheHelper, _, $q, WcConstants, $state) {
		this.authorizationEndpoint = new WcHttpEndpointPrototype('authorizations');

		this.requestAuthorization = function(name) {
			WcAuthorizationCacheHelper.addPolicy(name, this.authorizationEndpoint.get({params: {
				'authorizationString': name
			}}).then(function(response) {
				return response.data[0];
			}));
		};

		this.isAuthorizedFromCache = function(policy) {
			return WcAuthorizationCacheHelper.retrievePolicyAuthorization(policy);
		};

		/**
		 * @ngdoc method
		 * @name WcAuthorizationService.isStateAuthorized
		 * @methodOf WebCoreModule.service:WcAuthorizationService
		 * @param {String} stateName String identifying the state to check the user's authoization for.
		 * @returns {Promise} Promise object containing the results of the authorization check for the given state's policies.
		 * @description
		 * The isStateAuthorized function is a wrapper for the isAuthorized call when working with states. The function will
		 * find the authorization policies associated with the given state name and invoke isAuthorized to determine if the
		 * user is authorized to access the state.
		 */
		this.isStateAuthorized = function(stateName) {

			// Grab applicable policies from state's definition
			var state = $state.get(stateName);
			var policies = null,
				criteria = null;

			if (state.data) {
				policies = state.data.policies ? state.data.policies : null;
				criteria = state.data.criteria ? state.data.criteria : null;
			}

			// If state does not require any policy permissions, return true.
			if (!policies) {
				return $q.when(true);
			}

			// Set criteria to 'All' by default if not specified
			if (policies && !criteria) {
				criteria = WcConstants.authorization.all;
			}

			return this.isAuthorized(policies, criteria);
		};

		/**
		 * @ngdoc method
		 * @name WcAuthorizationService.isAuthorized
		 * @methodOf WebCoreModule.service:WcAuthorizationService
		 * @param {String|Array} policySet Set of policies to check authorization against.
		 * @param {String} criteria String identifying if the check should be for authorization against any or all of the policies.
		 * @returns {Promise} Promise object containing the results of the authorization check for the given policySet and criteria.
		 * @description
		 * The isAuthorized function checks if the current user is authorized for the given policy set. Checks are made via
		 * restful communications to the application server. The authorization service caches responses, to limit network
		 * traffic if multiple checks are required for the same policy. The function returns a promise that will resolve based
		 * on the given criteria. If 'All' is specified, the promise will be true if the user is authorized for all policies.
		 * If 'Any' is specified, the promise will be true if the user is authorized for any of the policies.
		 */
		this.isAuthorized = function(policySet, criteria) {

			if (!criteria) {
				criteria = WcConstants.authorization.all;
			}

			if (!angular.isArray(policySet)) {
				policySet = [policySet];
			}

			var authorizations = [];

			_.each(policySet, angular.bind(this, function(policy) {
				var isCached = this.isAuthorizedFromCache(policy);
				if (isCached === null) {
					this.requestAuthorization(policy);
					isCached = this.isAuthorizedFromCache(policy);
				}
				authorizations.push(isCached);
			}));

			return $q.all(authorizations).then(function(arrayOfAuths) {
				switch (criteria) {
					case 'Any':
						return _.some(arrayOfAuths);
					case 'All':
						return _.every(arrayOfAuths);
					default:
						return false;
				}
			});
		};
	}]);